import React, { useState } from 'react';
import { IntroStep } from '../components/face-analysis/IntroStep';
import { CameraStep } from '../components/face-analysis/CameraStep';
import { AnalyzingStep } from '../components/face-analysis/AnalyzingStep';
import { ResultsStep } from '../components/face-analysis/ResultsStep';
export type FaceAnalysisStep = 'intro' | 'camera' | 'analyzing' | 'results';
export function FaceAnalysisPage() {
  const [step, setStep] = useState<FaceAnalysisStep>('intro');
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const handleStart = () => setStep('camera');
  const handleCapture = (imageSrc: string) => {
    setCapturedImage(imageSrc);
    setStep('analyzing');
    // Simulate analysis delay
    setTimeout(() => {
      setStep('results');
    }, 3500);
  };
  const handleRetake = () => {
    setCapturedImage(null);
    setStep('camera');
  };
  return <div className="min-h-screen bg-brand-bg/30 pt-28 pb-20" data-id="element-608">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-609">
        {step === 'intro' && <IntroStep onStart={handleStart} data-id="element-610" />}
        {step === 'camera' && <CameraStep onCapture={handleCapture} data-id="element-611" />}
        {step === 'analyzing' && <AnalyzingStep data-id="element-612" />}
        {step === 'results' && capturedImage && <ResultsStep imageSrc={capturedImage} onRetake={handleRetake} data-id="element-613" />}
      </div>
    </div>;
}